import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./assets/main.scss"; // 全局样式

createApp(App).use(store).use(router).mount("#app");
